import React from "react";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";

const AutocompleteComponent = ({
  options,
  value,
  inputValue,
  onChange,
  isLoading,
  onInputChange,
  getOptionLabel,
  placeholder,
  disabled = false,
  size,
  label,
  sx = { width: "300px", backgroundColor: "#ffffff" },
}) => {
  return (
    <Autocomplete
      freeSolo
      autoSelect={false}
      autoHighlight={false}
      disabled={disabled}
      filterOptions={(x) => x}
      sx={sx}
      value={value}
      inputValue={inputValue}
      onChange={onChange}
      options={options ?? []}
      getOptionLabel={getOptionLabel}
      onInputChange={onInputChange}
      isOptionEqualToValue={(option, value) => {
        if (!option || !value) return false;
        return option.idtest_case === value.idtest_case;
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          fullWidth
          size={size}
          label={label}
          placeholder={placeholder}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
      renderOption={(props, option) => (
        <li
          {...props}
          key={option.idtest_case || option.value}
          style={{ wordBreak: "break-all", whiteSpace: "normal" }}
        >
          {getOptionLabel(option)}
        </li>
      )}
    />
  );
};

export default AutocompleteComponent;
